import React from "react";
import {useQuery} from "@apollo/client";
import {GET_SIAULIAI_DISCOUNTS} from "../../graphql/query";

export default function withSiauliaiDiscounts(WrappedComponent) {
    const useDiscountQuery = () => {
        const { loading, error, data } = useQuery(GET_SIAULIAI_DISCOUNTS, {fetchPolicy: 'no-cache'})
        if (error) {
            return {loading: false, error}
        }
        if (loading && (!data || !data.siauliaiDiscounts)) {
            return {loading: true}
        }
        if (data.siauliaiDiscounts.discounts) {
            const { list, user } = data.siauliaiDiscounts.discounts;
            const flatList = list.reduce((acc, discount) => {
                return acc.concat(discount.merchants.map(m => ({...discount,
                    merchant: m})));
            }, []);
            return {loading: false, discounts: {user, list: flatList}}
        } else {
            return {loading: false, discounts: {user: undefined, list: []}}
        }
    }

    return function () {
        return <WrappedComponent />
    }
}
